// extracted by css-extract-rspack-plugin
export default {"successIcon":"sidebar-actions-module__successIcon__bvdBr","successText":"sidebar-actions-module__successText__zknr2"};